<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>

    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">

      <template v-slot:title>
        {{ $t('Seller Default Terms') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="seller-default-terms-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="seller-default-terms-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>

      <div class="outer-container" v-if="selectedBranch">
        <div class="row">
          <div class="col-md-4">
            <input-widget :model="model" attribute="tax_status_uuid" type="select2"
                          display-field="${item.name}" :items="taxStatuses"/>
          </div>
          <div class="col-md-4">
            <input-widget :model="model" attribute="payment_terms" type="number"/>
          </div>
          <div class="col-md-4">
            <input-widget :model="model" attribute="settlement_days" type="number"/>
          </div>
          <div class="col-md-4">
            <currency-input-widget :model="model" attribute="unsold_fee"/>
          </div>
<!--          <div class="col-md-4">-->
<!--            <currency-input-widget :model="model" attribute="withdrawal_fee"/>-->
<!--          </div>-->
          <div class="col-md-4">
            <currency-input-widget :model="model" attribute="lot_handling_charge"/>
          </div>
          <div class="col-md-6 col-lg-4">
            <percentage-input-widget :model="model" attribute="insurance_rate"/>
          </div>
          <div class="col-md-12 footnote-textarea">
            <input-widget type="textarea" :model="model" attribute="vendor_settlement_footnote"/>
          </div>
        </div>
        <hr class="mt-0">
        <commission-tiers :model="model" show-minimum-commission-field/>
      </div>
      <no-data-available :height="5" v-else/>
    </b-tab>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import PercentageInputWidget from "../../../../../core/widgets/PercentageInputWidget";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget";
  import NoDataAvailable from "../../../../../core/components/common/NoDataAvailable";
  import CommissionTiers from "@/core/components/commission-tiers/CommissionTiers";

  const {mapState} = createNamespacedHelpers('setup/branch');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "Terms",
    components: {CommissionTiers, NoDataAvailable, CurrencyInputWidget, PercentageInputWidget, InputWidget},
    data() {
      return {};
    },
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['selectedBranch']),
      ...globalMapState(['taxStatuses']),
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      }
    },
    watch: {
      selectedBranch() {

        // this.initCommissions(); todo check if logic works without this line
      }
    }
  }
</script>

<style lang="scss" scoped>


   .footnote-textarea{
     /deep/ textarea{
       resize: none;
       height: 120px;
     }
   }
</style>
